<template>
  <el-select
    ref="select"
    style="width: 100%;"
    filterable
    remote
    :clearable="clearable"
    :value="value"
    :remote-method="remoteMethod"
    :loading="loading"
    :placeholder="placeholder"
    :disabled="disabled"
    v-bind="$attrs"
    @input="changeValue"
    @visible-change="showSelect"
    @focus.once="focus"
  >
    <el-option
      v-for="(item, index) in allOptions"
      :key="index"
      :label="getLabel(item, prop)"
      :value="getValue(item, prop)"
      :disabled="item.disabled === undefined ? optionDisabled(item) : item.disabled"
    >
      <slot :option="item" />
    </el-option>
  </el-select>
</template>

<script>
// element-ui的依赖项，不用额外加载
import debounce from 'throttle-debounce/debounce'

export default {
  props: {
    clearable: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    value: {},
    placeholder: {
      type: String,
      default: ''
    },
    api: {
      type: Function,
      default: () => new Promise(resolve => resolve({ records: [] }))
    },
    // eslint-disable-next-line
    prop: String,
    debounce: {
      type: Number,
      default: 300
    },
    getLabel: {
      type: Function,
      default: (item = {}, prop) => item[prop]
    },
    getValue: {
      type: Function,
      default: (item = {}, prop) => item[prop]
    },
    autoGetOptions: {
      type: Boolean,
      default: true
    },
    defaultOptions: {
      type: null,
      default: null
    },
    lazyLoad: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line
    disabled: {},
    // 选项禁用
    optionDisabled: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      options: [],
      valueOption: [],
      loading: false,
      keyword: '',
      current: 1,
      total: 0,
      hasMore: false
    }
  },
  computed: {
    isValueInOptions() {
      return this.options.map(i => i[this.prop]).includes(this.value)
    },
    allOptions() {
      if (this.value && this.valueOption.length && this.valueOption[0][this.prop] === this.value && !this.isValueInOptions) {
        return [this.valueOption[0], ...this.options]
      }
      return this.options
    }
  },
  watch: {
    disabled(val, old) {
      if (old === true && val === false) {
        this.getOptions()
      }
    }
  },
  async created() {
    if (this.defaultOptions) {
      this.options = this.defaultOptions()
    }

    this.remoteMethod = debounce(this.debounce, this.getOptions)
    // 设置autoGetOptions为false，将默认不会搜索
    if (!this.autoGetOptions || this.disabled || this.lazyLoad) return
    // 首次获取option数据
    const options = await this.getOptions('')
    this.$emit('created-options', options)
    // 有value时获取value和对应label项
    if (this.value && !this.$attrs.multiple && !this.isValueInOptions) {
      const data = await this.api({ keyword: this.value, current: 1 })
      const filterData = data && data.records.filter(i => i[this.prop] === this.value)
      if (filterData && filterData.length === 1) {
        this.valueOption = filterData
      }
    }
  },
  mounted() {
    const dropdown = this.$el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    dropdown && dropdown.addEventListener('scroll', () => {
      const CONDITION = dropdown.scrollHeight - dropdown.scrollTop <= dropdown.clientHeight
      if (CONDITION && this.hasMore) {
        this.getMoreOptions()
      }
    })
  },
  methods: {
    focus() {
      if (this.lazyLoad) {
        this.getOptions()
      }
    },
    async getOptions(keyword) {
      this.keyword = keyword
      this.loading = true
      try {
        const data = await this.api({ keyword, current: 1 })
        this.options = data.records || data
        this.total = data.total
        this.current = data.current || 1
        const pages = data.pages
        this.hasMore = (pages && pages > 1)

        this.loading = false
      } catch {
        this.loading = false
      }
      return this.options
    },
    async getMoreOptions() {
      this.current = this.current + 1
      const data = await this.api({ keyword: this.keyword, current: this.current })
      const options = data.records || []
      this.options.push(...options)
      this.total = data.total
      const current = data.current
      const pages = data.pages
      this.hasMore = (pages && current && current < pages)
    },
    changeValue(value, label) {
      const option = this.options.filter(i => i[this.prop] === value)
      const obj = option.length === 1 ? option[0] : {}
      this.$emit('input', value, label, obj)
    },
    showSelect(flag) {
      if (flag) {
        this.$nextTick(() => {
          this.$refs.select.selectedLabel = this.keyword || ''
          this.$refs.select.query = this.keyword || ''
          this.$refs.select.previousQuery = this.keyword || ''
        })
      }
    }
  }
}
</script>
